const ENDPOINT = 'SIGNcontract';
function signContract(gateway, params = null) {
    if (!params)
        return;
    return gateway.get(signContract.endpoint, params);
}
signContract.endpoint = ENDPOINT;

export { signContract as default };
//# sourceMappingURL=signContract.js.map
